import { normalizeLocale } from '@evi/shared';
import { fillSalesCopy, salesTeamCopy } from './salesTeamCopy';

/** Sales calendar dates retain their recorded YYYY-MM-DD in every timezone. Without a locale, or with an English one, the browser formats the date as it always has and the copy is English. */
export function salesEffectiveDate(value: string, locale?: string): string {
  const day = value.slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) return salesTeamCopy(locale).notRecorded;
  const dateLocale = locale && normalizeLocale(locale) !== 'en' ? locale : undefined;
  return new Date(`${day}T12:00:00Z`).toLocaleDateString(dateLocale, { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' });
}

export function salesStageTwoMonths<T extends { period: string }>(months: T[], effectiveFrom?: string): T[] {
  if (!effectiveFrom) return [];
  return months.filter(m => m.period >= effectiveFrom.slice(0, 7));
}

/** The currency a cents rate field reads back in: its object's currency, a USD or CAD threshold key, else USD. Null when the field is not cents. */
export function salesRateCentsCurrency(path: readonly string[], siblings: unknown): 'USD' | 'CAD' | null {
  const key = path.at(-1) ?? '', parent = path.at(-2) ?? '';
  if (key.endsWith('_cents')) return (siblings as { currency?: unknown } | null | undefined)?.currency === 'CAD' ? 'CAD' : 'USD';
  return parent.endsWith('_cents') && (key === 'USD' || key === 'CAD') ? key : null;
}

export function salesPoints(rateBps: number, locale?: string): string {
  const points = rateBps / 100, copy = salesTeamCopy(locale);
  return fillSalesCopy(points === 1 ? copy.pointOne : copy.pointOther, { n: points });
}

export function salesStatusTone(value: string): 'success' | 'error' | 'neutral' {
  const status = value.trim().toLowerCase().replaceAll('_', ' ');
  if (['active', 'approved', 'paid', 'launched', 'accepted', 'qualified', 'online'].includes(status)) return 'success';
  if (['rejected', 'inactive', 'offline', 'failed', 'reversed'].includes(status)) return 'error';
  // Pending and review states are informational, including themes where warn is red.
  return 'neutral';
}
